import { ImageTextCol, ImageTextColContainer } from '@definitions/types/storyblokTypes'

import { createImageTextCol } from '../../StoryblokImageTextCol/__mocks__/imageTextCol'

/**
 * Creates a mock ImageTextColContainer
 * @param overrides - Partial fields to override defaults
 * @returns Complete ImageTextColContainer mock
 */
export function createImageTextColContainer(
  overrides: Partial<ImageTextColContainer> = {}
): ImageTextColContainer {
  return {
    _uid: 'c30604c4-f2f2-4070-b8c0-e98d806f87da',
    subline: 'fddfsf',
    headline: 'dfsdffsf',
    component: 'image-text-col-container',
    imageTextCols: [
      createImageTextCol(),
      createImageTextCol({
        _uid: 'dcb1f49c-1dee-463e-8553-0dfb026848d1',
        headline: 'sdasdadd',
      }),
    ],
    _editable:
      '<!--#storyblok#{"name": "image-text-col-container", "space": "235453", "uid": "c30604c4-f2f2-4070-b8c0-e98d806f87da", "id": "322787899"}-->',
    ...overrides,
  }
}
